import RelatedEntityRelationship from "../../../../Global/Models/Related/RelatedEntityRelationship";
import BracketGameFixtureScoreModel from "../BracketGameFixtureScoreModel";
import BracketGameFixturesModel from "../BracketGameFixturesModel";
import BracketGameMetaModel from "../BracketGameMetaModel";
import BracketGameMetaParticipantsModel from "../BracketGameMetaParticipantsModel";
import BracketGameModel from "../BracketGameModel";
import BracketGamePredictionsModel from "../BracketGamePredictionsModel";
import BracketGamesModel from "../BracketGamesModel";
import BracketGameTiebreakerModel from "../BracketGameTiebreakerModel";
import BracketGamePredictionFixturesModel from "../Prediction/BracketGamePredictionFixturesModel";
import BracketGamePredictionModel from "../Prediction/BracketGamePredictionModel";
import BracketGameTiebreaker from "../Prediction/BracketGameTiebreaker";
import BracketGameFixtures from "../Prediction/RequestBody/BracketGameFixtures";
import BracketGameRankingsModel from "../Rankings/BracketGameRankingsModel";

export default class BracketGameRemapper {
  public remapBracketGames = (response: any) => {
    const model = new BracketGamesModel();

    model.meta.pagination.itemsPerPage =
      response.meta.pagination.items_per_page;
    model.meta.pagination.nextPageStartsAfter =
      response.meta.pagination.next_page_starts_after;
    model.data = response.data.map((d) => this.remapBracketGameById(d));

    return model;
  };

  public remapBracketGameById = (response: any) => {
    const model = new BracketGameModel();

    model.id = response.id;
    model.title = response.title;
    model.description = response.description;
    model.rules = response.rules;
    model.customFields = response.custom_fields;
    model.images = response.images;
    model.type = response.type;
    model.status = response.status;
    model.points = response.points;
    model.related = response.related
      ? this.remapRelated(response.related)
      : response.related;
    model.tiebreaker = response.tiebreaker
      ? this.remapBracketGameTiebreaker(response.tiebreaker)
      : response.tiebreaker;
    model.predictionsCutoff = response.predictions_cutoff;
    model.meta =
      response.meta && response.meta.participants
        ? this.remapBracketGameMeta(response.meta)
        : response.meta;
    model.fixtures = response.fixtures
      ? this.remapBracketGameFixtures(response.fixtures)
      : response.fixtures;
    model.createdAt = response.created_at;
    model.updatedAt = response.updated_at;

    return model;
  };

  public remapPredictionToRequestBody = (prediction: BracketGameFixtures[]) => {
    return prediction.map((p) => {
      return {
        match_id: p.matchId,
        participant_one: p.participantOne,
        participant_two: p.participantTwo,
        winner: p.winner,
      };
    });
  };

  public remapPrediction = (response: any) => {
    const model = new BracketGamePredictionModel();

    model.id = response.id;
    model.profileId = response.profile_id;
    model.gameId = response.game_id;
    model.totalPoints = response.total_points;
    model.gamePoints = response.game_points;
    model.bonusPoints = response.bonus_points;
    model.position = response.position;
    model.status = response.status;
    model.fixtures = this.remapPredictionFixtures(response.fixtures);
    model.tiebreaker = response.tiebreaker
      ? this.remapPredictionTiebreaker(response.tiebreaker)
      : response.tiebreaker;
    model.createdAt = response.created_at;
    model.updatedAt = response.updated_at;

    return model;
  };

  public remapPredictionsForUser = (response: any) => {
    const model = new BracketGamePredictionsModel();

    model.meta.pagination.itemsPerPage =
      response.meta.pagination.items_per_page;
    model.meta.pagination.nextPageStartsAfter =
      response.meta.pagination.next_page_starts_after;
    model.data = response.data.map((d) => this.remapPrediction(d));

    return model;
  };

  public remapRankings = (response: any) => {
    const model = new BracketGameRankingsModel();

    model.meta.pagination.itemsPerPage =
      response.meta.pagination.items_per_page;
    model.meta.pagination.nextPageStartsAfter =
      response.meta.pagination.next_page_starts_after;
    model.data = response.data.map((d) => this.remapPrediction(d));

    return model;
  };

  private remapRelated = (response: any[]) => {
    return response.map((r) => {
      const model = new RelatedEntityRelationship();

      model.entityId = r.entity_id;
      model.entityType = r.entity_type;
      model.entityRelationship = r.entity_relationship;

      return model;
    });
  };

  private remapPredictionFixtures = (response: any) => {
    return response.map((d) => {
      const model = new BracketGamePredictionFixturesModel();

      model.matchId = d.match_id;
      model.participantOne = d.participant_one;
      model.participantTwo = d.participant_two;
      model.winner = d.winner;
      model.correct = d.correct;

      return model;
    });
  };

  private remapPredictionTiebreaker = (response: any) => {
    const model = new BracketGameTiebreaker();

    model.statTotal = response.stat_total;

    return model;
  };

  private remapBracketGameMeta = (response: any) => {
    const model = new BracketGameMetaModel();

    model.participants = response.participants.map((p: any) => {
      const model = new BracketGameMetaParticipantsModel();

      model.id = p.id;
      model.name = p.name;
      model.group = p.group;
      model.image = p.image;
      model.undecided = p.undecided;

      return model;
    });

    return model;
  };

  private remapBracketGameFixtures = (response: any) => {
    return response.map((d) => {
      const model = new BracketGameFixturesModel();

      model.matchId = d.match_id;
      model.participantOne = d.participant_one;
      model.participantTwo = d.participant_two;
      model.winner = d.winner;
      model.homeParticipant = d.home_participant;
      model.startDate = d.start_date;
      model.score = d.score
        ? this.remapBracketGameFixturesScore(d.score)
        : d.score;

      return model;
    });
  };

  private remapBracketGameFixturesScore = (response: any) => {
    const model = new BracketGameFixtureScoreModel();

    model.participantOne = response.participant_one;
    model.participantTwo = response.participant_two;

    return model;
  };

  private remapBracketGameTiebreaker = (response: any) => {
    const model = new BracketGameTiebreakerModel();

    model.statTiebreakerEnabled = response.stat_tiebreaker_enabled;
    model.statTotal = response.stat_total;

    return model;
  };
}
